<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h1 class="box-title"><span class="fa fa-fw fa-calendar"></span> Availability</h1>
    </div>
    <div class="box-body">
      <div class="legend">
        <span class="fa fa-square fa-lg blue"></span> Your Booking
        <span class="fa fa-square-o fa-lg"></span> Available
        <span class="fa fa-square fa-lg grey"></span> Unavailable
        <span class="fa fa-square fa-lg red"></span> Conflict
        <span class="fa fa-square fa-lg yellow"></span> Relocation
      </div>
      <div class="calendar-display clearfix">
      <div class="calendar-col">
          <div class="calendar-row calendar-heading calendar-corner">
            <span class="fa fa-fw fa-caret-left interactive-cursor" v-on:click="leftAvailability()"></span>
            <span class="fa fa-fw fa-caret-right interactive-cursor" v-on:click="rightAvailability()"></span>
          </div>
          <template v-for="n in 24">
            <div class="calendar-row-header">{{ n | to_calendar_time }}</div>
          </template>
        </div>
        <template v-for="day in carAvailability" track-by="$index">
          <div class="calendar-col">
            <div class="calendar-row calendar-heading">{{ day.date }}</div>
            <template v-for="time in day.times" track-by="$index">
              <template v-if="time">
                <div v-bind:class="{ 'calendar-block-relo': time.reservationId == 'relo' && !time.overlap, 'calendar-block-selected': time.reservationId == reservation || time.overlap, 'calendar-block-clash': time.clash == true }" class="calendar-block-start calendar-block calendar-row" v-if="time.start == $index">
                  <span class="calendar-time">{{ time.startTime }}</span>
                </div>
                <div v-bind:class="{ 'calendar-block-relo': time.reservationId == 'relo' && !time.overlap, 'calendar-block-selected': time.reservationId == reservation || time.overlap, 'calendar-block-clash': time.clash == true }" class="calendar-block-end calendar-block calendar-row" v-if="time.end == $index">
                  <span class="calendar-time">{{ time.endTime }}</span>
                </div>
                <div v-bind:class="{ 'calendar-block-relo': time.reservationId == 'relo' && !time.overlap, 'calendar-block-selected': time.reservationId == reservation || time.overlap, 'calendar-block-clash': time.clash == true }" class="calendar-block calendar-row" v-if="time.end !== $index && time.start !== $index"></div>
              </template>
              <template v-else>
                <div class="calendar-row" v-bind:class="{ 'calendar-blank': ($index+1) % 4 !== 0 }"></div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default{
  name: 'CarAvailability',
  props: {
    car: {
      type: Object
    },
    date: {
      type: Date
    },
    search: {
      type: Object
    }
  },
  data () {
    return {
      carAvailability: [
        { date: 'Mo 18th' }
      ]
    }
  },
  methods: {
    leftAvailability () {
      this.date = moment(this.date).subtract(1, 'day').hours(0).minutes(0).format()
      this.loadAvailability()
    },
    rightAvailability () {
      this.date = moment(this.date).add(1, 'day').hours(0).minutes(0).format()
      this.loadAvailability()
    },
    loadAvailability () {
      let authType = this.$route.authType
      if (this.car.uuid) {
        this.$http.post(`${authType}/reserve/carAvailability`, { startDate: this.date, carUuid: this.car.uuid }).then(({ data }, status, request) => {
          let availability = []
          let m = moment(this.date).hour(0).minutes(0).seconds(0)
          this.date = m.format()
          for (let i = 0; i < 7; i++) {
            let x = { date: '', times: new Array(96) }
            x.date = m.clone().add(i, 'days').format('dd D/M')
            availability.push(x)
          }
          if (data.availability) {
            let proposedRes = {
              startDate: this.search.startDate,
              endDate: this.search.endDate
            }
            data.availability.Reservations.push(proposedRes)
            for (let reservation of data.availability.Reservations) {
              let resStart = moment(reservation.blockedStartDate)
              let resEnd = moment(reservation.blockedEndDate)
              let start = parseInt(resStart.diff(m, 'minutes') / 15)
              let end = parseInt(resEnd.diff(m, 'minutes') / 15)
              let totalBlocks = end - start
              let blocksPlaced = 0
              let currentBlock = 0
              let currentBlockEnd = 0
              let currentCol = parseInt(start / 96)
              while (blocksPlaced < totalBlocks) {
                // start > 95 = mid week booking
                if (start > 95) {
                  start = parseInt(start - 96 * currentCol)
                }
                if (end > 95) {
                  currentBlockEnd = parseInt(end - 96 * currentCol)
                  while (currentBlockEnd > 96) {
                    currentBlockEnd = 96
                  }
                } else if (totalBlocks < 96) {
                  currentBlockEnd = end
                } else {
                  currentBlockEnd = 9
                }
                if (start + currentBlock > 95) {
                  currentBlock = 0
                  currentCol++
                  start = 0
                }
                if (availability[currentCol]) {
                  if (availability[currentCol].times[start + currentBlock]) {
                    if (availability[currentCol].times[start + currentBlock].reservationId !== 'relo' && !reservation.OriginalLotUuid) {
                      availability[currentCol].times[start + currentBlock].clash = true
                    } else if (availability[currentCol].times[start + currentBlock].reservationId === 'relo') {
                      availability[currentCol].times[start + currentBlock].overlap = true
                    }
                  } else {
                    let block = {
                      start,
                      end: currentBlockEnd - 1,
                      startTime: resStart.format('h:mma'),
                      endTime: resEnd.format('h:mma'),
                      reservationId: reservation.reservationId,
                      reservationUuid: reservation.uuid,
                      clash: false
                    }
                    if (reservation.OriginalLotUuid) {
                      if (reservation.permanent) {
                        block.reservationId = 'perm-relo'
                      } else {
                        block.reservationId = 'relo'
                      }
                    }
                    availability[currentCol].times[start + currentBlock] = block
                  }
                }
                currentBlock++
                blocksPlaced++
              }
            }
          }
          this.carAvailability = availability
        })
      }
    }
  },
  watch: {
    'car': function (newVal, oldVal) {
      this.loadAvailability()
    }
  }
}
</script>



// WEBPACK FOOTER //
// CarAvailability.vue?32523f9c